import { createTheme } from '@material-ui/core/styles'
import { ERROR_THEME } from './themes/error-theme'
import { TELECABLE_THEME } from './themes/telecable-theme'
import { R_THEME } from './themes/r-theme'
import { EUSKALTEL_THEME } from './themes/euskaltel-theme'
import { useSelector } from 'react-redux'

const themes = {
  k: createTheme(EUSKALTEL_THEME),
  r: createTheme(R_THEME),
  t: createTheme(TELECABLE_THEME),
  error: createTheme(ERROR_THEME)
}

export default function Theme() {
  const brand = useSelector((state) => state.reducer.brand)
  const key = brand?.abbreviation?.toLowerCase()

  return brand ? themes[key] : themes['error']
}
